import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.strong`
  display: block;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 16px;
`;

export const Box = styled.div<{ $isCheckboxSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 16px 16px 16px 8px;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-bottom: ${({ $isCheckboxSelected }) => ($isCheckboxSelected ? '8px' : '24px')};
  background: #fff;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconUI = styled.div`
  width: 30px;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: #575757;
  max-width: 210px;
  margin-left: 26px;
`;

export const ServiceName = styled.span`
  font-weight: bold;
`;

export const PriceUI = styled.span`
  font-weight: bold;
  color: #282828;
`;

export const BoxAnchor = styled.a`
  display: block;
  color: ${({ theme }) => theme.grey.dark};
  text-decoration: underline;
  line-height: 16px;
  margin-top: 2px;
  cursor: pointer;
`;

export const Disclaimer = styled.p`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 14px;
  color: #6f6f6f;
  margin-bottom: 24px;
  margin-left: 15px;
`;

export const DisclaimerAnchor = styled.a`
  text-decoration: underline;
  line-height: 16px;
  margin-top: 2px;
  cursor: pointer;
`;
